import styled from 'styled-components'
import { theme } from '../../../theme/theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: ${theme.colors.background.primary};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  background: ${theme.colors.background.secondary};
  border-bottom: 1px solid ${theme.colors.border.primary};
  position: sticky;
  top: 0;
  z-index: 2;
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 600;
  color: ${theme.colors.text.primary};
`

export const TitleIcon = styled.div`
  color: ${theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CountBadge = styled.span`
  background: ${theme.colors.primaryLight};
  color: ${theme.colors.primary};
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
`

export const CloseButton = styled.button`
  width: 26px;
  height: 26px;
  background: ${theme.colors.background.primary};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  color: ${theme.colors.text.secondary};

  &:hover {
    background: ${theme.colors.background.secondary};
    border-color: ${theme.colors.text.tertiary};
    transform: translateY(-1px);
  }
`

export const SearchContainer = styled.div`
  padding: 12px;
  background: ${theme.colors.background.primary};
  border-bottom: 1px solid ${theme.colors.border.light};
`

export const SearchBarRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.small};
`

export const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${theme.spacing.small} ${theme.spacing.default};
  background: ${theme.colors.background.primary};
`

export const SearchResultsInfo = styled.div`
  padding: 6px 20px;
  font-size: 11px;
  color: ${theme.colors.text.secondary};
  background: ${theme.colors.background.tertiary};
  border-bottom: 1px solid ${theme.colors.border.light};
  display: none;

  &.show {
    display: block;
  }

  strong {
    color: ${theme.colors.text.primary};
    font-weight: 600;
  }
`

export const ListContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  background: ${theme.colors.background.secondary};
  display: flex;
  flex-direction: column;
  gap: 6px;

  &::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }
`

export const NoResults = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 38px 20px;
  text-align: center;

  &.show {
    display: flex;
  }
`

export const NoResultsIcon = styled.div`
  width: 38px;
  height: 38px;
  color: ${theme.colors.text.tertiary};
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const NoResultsTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin-bottom: 6px;
`

export const NoResultsText = styled.div`
  font-size: 12px;
  color: ${theme.colors.text.secondary};
  margin-bottom: 16px;
`

export const ClearSearchButton = styled.button`
  padding: 6px 12px;
  background: ${theme.colors.primary};
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;

  &:hover {
    background: ${theme.colors.primaryHover};
    transform: translateY(-1px);
  }
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 38px 20px;
  text-align: center;
`

export const EmptyIcon = styled.div`
  width: 38px;
  height: 38px;
  color: ${theme.colors.text.tertiary};
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const EmptyTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin-bottom: 6px;
`

export const EmptyText = styled.div`
  font-size: 12px;
  color: ${theme.colors.text.secondary};
`
